import PocEdit from './PocEdit'
import { PocDescriptor } from 'poc/factory'
import { apiMocker } from 'poc/apiMock'
import {
  Create,
  Datagrid,
  List,
  required,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin'
import React from 'react'

type Model = {
  id: number
  title: string
  highlights: { item: string }[]
}

const MOCK: Model[] = [
  {
    id: 1,
    title: 'test1',
    highlights: Array.from({ length: 100 }, (_, i) => ({
      item: `highlight ${i}`,
    })),
  },
  {
    id: 2,
    title: 'test2',
    highlights: Array.from({ length: 100 }, (_, i) => ({
      item: `highlight ${i}`,
    })),
  },
]

const PocCreate = () => {
  return (
    <Create>
      <SimpleForm>
        <TextInput source="title" validate={[required()]} fullWidth />
      </SimpleForm>
    </Create>
  )
}

const PocList = () => (
  <List exporter={false}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="title" />
    </Datagrid>
  </List>
)

const cfg: PocDescriptor = {
  dp: apiMocker(MOCK),
  forms: { list: PocList, edit: PocEdit, create: PocCreate },
}

export default cfg
